import React from 'react';
import PropTypes from 'prop-types';

import { ThreadsTableViewModel } from 'four-nets/forum/threads-table/threads-table-view';
import ErrorPage from 'four-nets/errors/error-page';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';

import UpdatedTopicsView from './updated-topics-view';
import { CategoryStore } from '../forum';

class UpdatedTopicsLoader extends React.PureComponent {
    static contextTypes = {
        categoryStore: PropTypes.instanceOf(CategoryStore),
    };

    transform = data => {
        const { categoryStore } = this.context;

        const threads = categoryStore.threadStore.processPagedJSON({ json: data.threadsTableViewModel.threads });

        const threadsTableViewModel = new ThreadsTableViewModel();
        threadsTableViewModel.setThreads(threads);

        return {
            threadsTableViewModel,
        };
    };

    fetch = (setData, { page = 1 }) => {
        const { categoryStore } = this.context;

        return categoryStore.threadStore.loadMostActive({ page, pager: 'paged_40' }).then(threads => {
            const threadsTableViewModel = new ThreadsTableViewModel();
            threadsTableViewModel.setThreads(threads);

            setData({
                threadsTableViewModel,
            });
        });
    };

    renderFetch = ({ loading, error, data }) => {
        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    <UpdatedTopicsView loading={loading} threadsTableViewModel={data?.threadsTableViewModel} />
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        const { page } = this.props.search;

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                page={page}
            />
        );
    }
}

export default UpdatedTopicsLoader;
